<div *ngIf="isAdminSubject.asObservable() | async as isAdmin" class="card">

	<div class="card-body">
		<h5 class="card-title">Function app overview</h5>
		<div *ngIf="!(isLoadingFunctionAppsInfo | async); else loading">
			<div *ngIf="functionApps$ | async as functionAppItems" class="list-container">
				<dx-data-grid [dataSource]="functionAppItems" height="100%" [showBorders]="true" (onRowInserted)="rowInserted($event)" (onRowRemoving)="rowRemoving($event)" (onRowUpdating)="rowUpdating($event)">
					<dxo-editing [allowUpdating]="true" [allowAdding]="true" [allowDeleting]="true" mode="row">
						<!-- 'batch' | 'cell' | 'form' | 'popup' -->
					</dxo-editing>
					<dxo-selection [showCheckBoxesMode]="'none'"></dxo-selection>
					<dxi-column caption="" [width]="15" alignment="left" [allowEditing]="false"></dxi-column>
					<dxi-column dataField="statusCode" caption="Status" [width]="100" cellTemplate="cellTemplate" [allowEditing]="false" sortOrder="desc"></dxi-column>
					<dxi-column dataField="deployedVersion" caption="Deployed app version" [width]="150"></dxi-column>
					<dxi-column dataField="deployedApp" caption="Deployed app type" [width]="150"></dxi-column>
					<dxi-column dataField="functionApps.isDefault" caption="Default app" [width]="150" sortOrder="desc"></dxi-column>
					<div *dxTemplate="let data of 'cellTemplate'">
						<ng-container *ngIf="data.value == 'OK'">
							<div class="led-green" title="Online"></div>
						</ng-container>
						<ng-container *ngIf="data.value == 'NotFound'">
							<div class="led-yellow" title="Endpoint not available"></div>
						</ng-container>
						<ng-container *ngIf="!data.value">
							<div class="led-red" title="Offline"></div>
						</ng-container>
					</div>
					<dxi-column dataField="functionApps.applicationId" caption="Application">
						<dxo-lookup [dataSource]="applications$ | async" displayExpr="name" valueExpr="id"></dxo-lookup>
					</dxi-column>
					<dxi-column dataField="functionApps.name" sortOrder="asc" caption="Name of function app"></dxi-column>
					<dxi-column dataField="functionApps.description" caption="Function app description"></dxi-column>
					<dxi-column dataField="functionApps.url" caption="URL"></dxi-column>
					<dxi-column dataField="functionApps.masterKey" caption="Master key"></dxi-column>
					<dxi-column dataField="functionApps.systemKey" caption="System key"></dxi-column>

					<dxo-master-detail [enabled]="true" template="detailed"></dxo-master-detail>
					<div *dxTemplate="let function of 'detailed'">
						<detailed-grid-functionapps [applicationLinkEndpointInformation]="function.key.applicationLinkEndpointInformation">
						</detailed-grid-functionapps>
					</div>
				</dx-data-grid>
			</div>
		</div>

		<ng-template #loading>Loading....</ng-template>


		<h6>Select company</h6>
		<div *ngIf="companies$ | async as companies">
			<dx-select-box [searchEnabled]="true" [items]="companies" displayExpr="fullIdentifier" valueExpr="id" (onValueChanged)="selectCompany($event)"></dx-select-box>
		</div>

		<div *ngIf="linksConfiguration$ | async as linkConfiguration">
			<dx-data-grid [dataSource]="linkConfiguration" height="100%" [showBorders]="true">
				<dxo-selection [showCheckBoxesMode]="'none'"></dxo-selection>

				<dxi-column dataField="id" [width]="50" caption="Link ID"></dxi-column>
				<dxi-column dataField="name" caption="Link name"></dxi-column>
				<dxi-column dataField="fromDName" caption="From"></dxi-column>
				<dxi-column dataField="toDName" caption="To"></dxi-column>

				<dxo-master-detail [enabled]="true" template="detailed"></dxo-master-detail>
				<div *dxTemplate="let function of 'detailed'">
					<detailed-grid-link-functionapps [link]="function.key" [applications]="applications$ | async" [linkTemplates]="linkTemplates$ | async">
					</detailed-grid-link-functionapps>
				</div>
			</dx-data-grid>
		</div>


	</div>
</div>